import { useAuth } from "@/contexts/AuthContext";
import { Navigate } from "react-router-dom";
import { Shield, Loader2 } from "lucide-react";

interface RequireRoleProps {
  children: React.ReactNode;
}

/**
 * Admin route guard — only SUPER_ADMIN can access.
 */
export function RequireRole({ children }: RequireRoleProps) {
  const { isAuthenticated, isLoading, user } = useAuth();

  // Auth is still resolving (boot with CSRF cookie, or just-logged-in refetch).
  // Show a loader instead of bouncing to /login on an authenticated user.
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (user?.staffRole !== "SUPER_ADMIN") {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-center space-y-4">
          <div className="flex justify-center">
            <div className="rounded-full bg-destructive/10 p-4">
              <Shield className="h-10 w-10 text-destructive" />
            </div>
          </div>
          <h2 className="text-xl font-semibold">Accès refusé</h2>
          <p className="text-sm text-muted-foreground">
            Seul le Super Admin peut accéder à la tour de contrôle.
          </p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
